<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="礼品券" name="second">
        <giftTable/>
      </el-tab-pane>
      <el-tab-pane label="兑换券" name="first">
        <exchangeTable/>
      </el-tab-pane>
  </el-tabs>
  </div>
</template>
<script>
import exchangeTable from './components/exchangeTable.vue';
import giftTable from './components/giftTable.vue';

export default {
  data() {
    return {
      activeName: 'second',
    };
  },
  components: {
    exchangeTable,
    giftTable,
  },
  methods: {
    handleClick() {},
  },
};
</script>
<style lang="stylus" scoped>
>>>.el-tabs__nav-wrap
  &::after
    height 1px!important

</style>
